import { BillingInfoResponse, BillingInfo, PaymentMethodMap, PaymentMethodType } from '@/types'

const reduceUserBillingInfo = (billingInfoResponse: BillingInfoResponse): BillingInfo => {
  const {
    paymentMethod: { object: paymentMethodObject, cardType, lastFour, expYear, expMonth },
    address: addressResponse
  } = billingInfoResponse

  const paymentMethodTypeMap: PaymentMethodMap = {
    credit_card: PaymentMethodType.creditCard,
    paypal_billing_agreement: PaymentMethodType.payPal,
    cash_app: PaymentMethodType.cashApp,
    sepa: 'sepa'
  }

  const type = paymentMethodTypeMap[paymentMethodObject]
  const { postalCode, country } = addressResponse

  return {
    cardType,
    lastFour,
    expYear,
    expMonth,
    type,
    address: {
      postalCode,
      country
    }
  }
}

export default reduceUserBillingInfo
